import { render, staticRenderFns } from "./RequestAction.vue?vue&type=template&id=61f73bcc&scoped=true"
var script = {}
import style0 from "./RequestAction.vue?vue&type=style&index=0&id=61f73bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f73bcc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,VImg: require('/var/www/tubber-new/components/global/v/img.vue').default})
